import { render, staticRenderFns } from "./KnContactInfo.vue?vue&type=template&id=213691b2&"
import script from "./KnContactInfo.vue?vue&type=script&lang=js&"
export * from "./KnContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports